import React from 'react';
import { Box } from '@mui/material';
import { ColorPalette } from '../../../../../components/config';
import { RestrictedCitizenLabel } from '../../restricted-citizen-label';
import { attendanceColumnMarginLeft, attendanceColumnMinWidth, citizenRowMinHeight, notRelevantColumnMarginLeft, notRelevantColumnMinWidth } from './attendance-column-layout';

const restrictedCitizenBackgroundColor = ColorPalette.Card;

interface IRestrictedCitizenAttendanceProtocolProps {
  showStartAttendanceRegistration: boolean;
  showEndAttendanceRegistration: boolean;
}

export function RestrictedCitizenAttendanceProtocol(props: IRestrictedCitizenAttendanceProtocolProps) {
  const { showStartAttendanceRegistration, showEndAttendanceRegistration } = props;
  const showAttendanceColumns = showStartAttendanceRegistration || showEndAttendanceRegistration;

  return (
    <Box display="flex" alignItems="stretch" minHeight={citizenRowMinHeight}>
      <Box flex={1} minWidth={0} display="flex" alignItems="center" sx={{ backgroundColor: restrictedCitizenBackgroundColor, borderRadius: 1, padding: 2 }}>
        <RestrictedCitizenLabel />
      </Box>
      {showStartAttendanceRegistration && <EmptyAttendanceColumn minWidth={attendanceColumnMinWidth} marginLeft={attendanceColumnMarginLeft} />}
      {showEndAttendanceRegistration && <EmptyAttendanceColumn minWidth={attendanceColumnMinWidth} marginLeft={attendanceColumnMarginLeft} />}
      {showAttendanceColumns && <EmptyAttendanceColumn minWidth={notRelevantColumnMinWidth} marginLeft={notRelevantColumnMarginLeft} />}
    </Box>
  );
}

function EmptyAttendanceColumn({ minWidth, marginLeft }: { minWidth: number; marginLeft: string }) {
  return <Box marginLeft={marginLeft} minWidth={minWidth} sx={{ backgroundColor: restrictedCitizenBackgroundColor, borderRadius: 1 }} />;
}
